// ponytail: single flag hides legacy permission/deploy tools during the Context Engine rebrand.
// Flip to true to bring them all back (nav tabs, routes, landing cards).
export const SHOW_LEGACY_TOOLS = false;
